<template>
  <v-col :class="listClass" v-if="users">
    <v-avatar size="25px" v-for="(user, idx) in users" :key="`avatar-${user.id}-${idx}`">
      <v-tooltip top transition="fade-transition">
        <template v-slot:activator="{ on }">
          <img v-if="user.avatar" :src="user.avatar" v-on="on" />
          <v-icon v-else v-text="$vuetify.icons.values.user" v-on="on" />
        </template>
        <span>{{ user.display }}</span>
      </v-tooltip>
    </v-avatar>
  </v-col>
</template>

<script>
export default {
  name: 'AvatarList',
  props: {
    users: Array,
    alignRight: { type: Boolean, default: false }
  },
  computed: {
    listClass() {
      return {
        'text-right': this.alignRight,
        'py-1': true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.v-avatar {
  padding: 15px;
  margin: -4px;
  background-color: #ffffff;

  .v-icon {
    margin: 4px;
  }
}
</style>
